import withModal from 'src/hoc/withModal'

import SubmitDialog from './SubmitDialog'

export default withModal(SubmitDialog)
